import { Close, Done } from '@mui/icons-material';
import { Box, IconButton, TableCell, TableRow, TextField, Tooltip } from '@mui/material';
import React from 'react';
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../../../components/snackBar/snakbar';
import { API, graphqlOperation } from 'aws-amplify';
import { updatePriceType } from '../../../graphql/mutations';
import { createPriceType } from '../../../graphql';
import { useCreatePriceTypeMutation } from '../../../redux/apis/pricetype.api';
import useSaveShortcut from '../../../hooks/useSaveShortcut';
import useSaveModalShortcut from '../Components/useSaveModalShortcut';
import moment from 'moment';
import { useSelector } from 'react-redux';

function AddNewPriceTypeRow({
  rows,
  setRows,
  editedRows,
  setEditedRows,
  loading,
  setAddEvent,
  setPriceTypeID,
  priceTypeID,
  updatePriceRow,
  rowIndex,
  setUpdatedRows,
  ind,
  setNewPriceTypeID,
  setLoading,
}) {
  const [
    createPriceType,
    { isLoading: iscreatePriceType, isError: iscreatePriceTypeError, isSuccess: iscreatePriceTypeSuccess, error: createPriceTypeError },
  ] = useCreatePriceTypeMutation();
  const userPreferenceAndFY = useSelector(
        (state) => state.userPrefrenceandReducer
      );
      const fyStartDate = moment(
        userPreferenceAndFY.financialYear.startdate * 1000
      ).format("YYYY-MM-DD");
  async function saveChanges() {
    try {
      let isValid = true;
      let editedObj = { ...editedRows };
      if (editedObj.priceType.trim() === '') {
        isValid = false;
      }

      if (isValid) {
        if (priceTypeID === '') {
          let obj = {
            pricetype: editedObj.priceType,
            is_default: 0,
            is_active: 1,
          };
          addPriceType(obj);
        } else {
          let obj = {
            pricetype: editedObj.priceType,
            is_active: 1,
            id: editedObj.Id,
            expiredtimestamp: 0,
            is_default: 0,
          };
          editPriceType(obj);
        }
      } else {
        showWarningSnackbar('Please Enter the Price Type');
      }
    } catch (e) {
      console.log('error', e);
    }
  }
  async function addPriceType(obj) {
    try {
      setLoading(true);
      const resItem = await createPriceType({
        pricetype: JSON.stringify([obj]),
      });
      // const resItem = await API.graphql(
      //   graphqlOperation(createPriceType, {
      //     pricetype: JSON.stringify([obj]),
      //   })
      // );
      if (resItem.data?.statuscode === 'Success') {
        setNewPriceTypeID(resItem.data?.id);
        showSuccessSnackbar('New Price Type added successfully');

        updatePriceRow[rowIndex] = {
          ...updatePriceRow[rowIndex],
          priceType: {
            label: resItem.data?.pricetype,
            value: resItem.data?.id,
          },
          effectivefrom:fyStartDate
        };
        setUpdatedRows(updatePriceRow);
        setLoading(false);
      } else {
        showErrorSnackbar(resItem?.error?.message);
        setLoading(false);
      }
    } catch (error) {
      console.log('error', error);
      setLoading(false);
      const rawMessage = error.errors[0].message.split('RDSHttp:')[1];
      const parsedMessage = JSON.parse(rawMessage).message;
      const errorMessage = parsedMessage.split('ERROR: ')[1].split(';')[0];
      showWarningSnackbar(errorMessage);
    } finally {
      setLoading(false);
    }
  }
  async function editPriceType(obj) {
    try {
      setLoading(true);
      // const resItem = await API.graphql(
      //   graphqlOperation(createPriceType, {
      //     pricetype: JSON.stringify([obj]),
      //   })
      // );
      const resItem = await createPriceType({
        pricetype: JSON.stringify([obj]),
      });

      if (resItem.data?.statuscode === 'Success') {
        showSuccessSnackbar('Price Type updated');
        // setPriceTypeID(resItem.data.updatePriceType.ID)

        updatePriceRow[rowIndex] = {
          ...updatePriceRow[rowIndex],
          priceType: {
            label: resItem.data?.pricetype,
            value: resItem.data?.id,
          },
        };
        setUpdatedRows(updatePriceRow);
        setLoading(false);
      } else {
        showErrorSnackbar(resItem?.error?.message);
        setLoading(false);
      }
    } catch (error) {
      console.log('err', error);
      setLoading(false);
      const rawMessage = error.errors[0].message.split('RDSHttp:')[1];
      const parsedMessage = JSON.parse(rawMessage).message;
      const errorMessage = parsedMessage.split('ERROR: ')[1].split(';')[0];
      showWarningSnackbar(errorMessage);
    } finally {
      setLoading(false);
    }
  }
  useSaveModalShortcut(saveChanges);
  return (
    <TableRow
      className="TableCellBorder"
      sx={{
        height: '20px',
        '.MuiTableCell-root': {
          backgroundColor: 'transparent !important',
        },
      }}
    >
      <TableCell>
        {/* {editedRows?.Id} */}
        {!isNaN(ind) ? ind + 1 : ''}
      </TableCell>
      <TableCell>
        <TextField
          id="priceType"
          name="priceType"
          size="small"
          autoFocus
          value={editedRows?.priceType}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              saveChanges();
            }
          }}
       onChange={(e) => {
  let value = e.target.value;

  value = value.trimStart();

 
  value = value
    .split(/\s+/) 
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  setEditedRows((prev) => ({
    ...prev,
    priceType: value,
  }));
}}

          inputProps={{
            maxLength: 25,
          }}
          sx={
            {
              // "& fieldset": { border: "none" },
            }
          }
        />
      </TableCell>
      <TableCell align="center">
        <Box
          id="Action"
          tabIndex="0"
          sx={{
            width: 80,
            whiteSpace: 'nowrap',
            position: 'relative',
            left: '50%',
            transform: 'translate(-50%)',
            outline: 'none',
          }}
        >
          <Tooltip title={'Save'} placement="right" disableInteractive arrow>
            <IconButton
              id="Save"
              disableRipple
              aria-label="delete"
              sx={{
                margin: '0px 2px',
                padding: '5px',
                backgroundColor: '#83ff7b7a',
              }}
              disabled={loading}
              onClick={saveChanges}
            >
              <Done sx={{ fontSize: '15px', color: '#34994f' }} />
            </IconButton>
          </Tooltip>

          <Tooltip title={'cancel'} placement="right" disableInteractive arrow>
            <IconButton
              id="cancel"
              onClick={(event) => {
                if (editedRows?.Id === '') {
                  setAddEvent(false);
                } else {
                  let arr = [...rows];
                  let tempArr = arr.filter((ele, index) => {
                    if (ele.new !== true) {
                      if (ele.itemId == editedRows.itemId) {
                        ele.editable = false;
                        ele.new = false;
                      }
                      return ele;
                    }
                  });
                  setRows(tempArr);
                }
              }}
              aria-label="delete"
              sx={{
                margin: '0px 2px',
                padding: '5px',
                backgroundColor: '#fbc7c78c',
              }}
            >
              <Close sx={{ fontSize: '15px', color: '#eb6a6a' }} />
            </IconButton>
          </Tooltip>
        </Box>
      </TableCell>
    </TableRow>
  );
}

export default AddNewPriceTypeRow;
